/**
 * Approval Handlers Registry
 *
 * Module-level registry to store approval handlers outside Redux state.
 * This avoids Redux serialization issues with non-serializable functions.
 *
 * Registry maps noteId to approval/rejection handler functions.
 */

export const approvalHandlersRegistry = new Map<
  string,
  { onApprove: () => void; onReject: () => void }
>();

/**
 * Get approval handlers for a specific note
 * @param noteId - The note ID to retrieve handlers for
 * @returns Handler functions or undefined if not found
 */
export const getApprovalHandlers = (noteId: string) => approvalHandlersRegistry.get(noteId);
